<!--
 * @Author: hongye
 * @Date: 2020-09-23 13:57:17
 * @LastEditTime: 2020-09-23 16:01:46
 * @Description: 
-->
<template>
  <div>
    <el-table v-if="codeList.length"  :data="codeList" border style="width:100%;border-radius: 4px;" max-height="600px">
      <el-table-column prop="code" :label="$t('apiTestDoc.错误编码')"></el-table-column>
      <el-table-column prop="msg" :label="$t('apiTestDoc.错误描述')"></el-table-column>
    </el-table>
  </div>
</template>

<script>
// const codeList = [
//     {code:"1",msg:"success"},
//     {code:"0",msg:`${this.$t('apiDoc.失败')}`},
//     {code:"145003030",msg:`${this.$t('apiDoc.Headers签名失败')}`},
//     {code:"145003040",msg:`${this.$t('apiDoc.内部调用异常')}`},
//     {code:"145003071",msg:`${this.$t('apiDoc.apiAccount为空')}`},
//     {code:"145003052",msg:`${this.$t('apiDoc.digest为空')}`},
//     {code:"145003053",msg:`${this.$t('apiDoc.timestamp为空')}`},
//     {code:"145005000",msg:`${this.$t('apiDoc.系统错误')}`},
//     {code:"145003050",msg:`${this.$t('apiDoc.非法参数')}`},
// ]

export default {
  props: {
    dataList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data(){
      return{
          // codeList:[...this.codeListOld,...this.dataList]
      }
  },
  computed:{
    codeList(){
      return [...this.codeListOld,...this.dataList]
    },
    codeListOld(){
      return  [
    {code:"1",msg:"Succeed"},
    {code:"0",msg:this.$t('apiDoc.失败')},
    {code:"145003030",msg:this.$t('apiDoc.Headers签名失败')},
    {code:"145003040",msg:this.$t('apiDoc.内部调用异常')},
    {code:"145003071",msg:this.$t('apiDoc.apiAccount为空')},
    {code:"145003052",msg:this.$t('apiDoc.digest为空')},
    {code:"145003053",msg:this.$t('apiDoc.timestamp为空')},
    {code:"145005000",msg:this.$t('apiDoc.系统错误')},
    {code:"145003050",msg:this.$t('apiDoc.非法参数')},
]
      
    }
  },
};
</script>

<style>
</style>